/**
 * Módulo: Club Milbrands (grupo de sidebar)
 *
 * NO es un vertical con lógica propia: es el GRUPO del sidebar que agrupa los
 * módulos del Club — Formación (ola 1) y, a medida que salgan, Comunidad,
 * Eventos y Empleo. Mismo patrón que `supervision` (7-jul-2026): acá viven solo
 * los ÍTEMS del menú; las rutas las montan los módulos de origen.
 *
 * Por qué existe como módulo aparte y no como grupo dentro de `formacion`:
 * los 4 módulos del Club son independientes y VENDIBLES POR SEPARADO (decisión
 * de Mariano, 20-ago-2026 — un tenant puede comprar solo `eventos`). Si el
 * grupo colgara de uno de ellos, el sidebar se rompería al desactivarlo.
 *
 * "Club Milbrands" es marca, no arquitectura: el grupo se llama así porque hoy
 * el único operador es Milbrands. Cuando otro tenant opere su propio club, el
 * nombre visible sale de branding, no de un literal (ver ADR rector del Club).
 *
 * Gating: el grupo aparece si el rol tiene 'ver' sobre alguno de los módulos
 * del Club (permisoModulos) Y el módulo `club` está habilitado por el plan de
 * la empresa (misma mecánica que cualquier otro módulo del registry).
 */
export default {
  id: 'club',
  nombre: 'Club Milbrands',
  descripcion: 'Grupo del sidebar: formación, comunidad, eventos y empleo del Club',
  icono: 'award',
  tipo: 'core',
  version: '0.1.0',

  // Producto para clientes desde el día uno (Ruta B). Excepción explícita al
  // default de `.claude/patterns/modulo-nuevo.md` (que arranca solo-staff):
  // el Club sale para usuarios de empresas clientes, no es back-office.
  milbrandsInterno: false,

  // Sin rutas propias: los ítems apuntan a rutas de los módulos del Club.
  routes: [],

  menuItems: [
    { label: 'Formación', path: '/formacion', icon: 'book-open', permisoModulo: 'formacion' },
    { label: 'Eventos', path: '/eventos', icon: 'calendar', permisoModulo: 'eventos' },
    // Ola 2 → Comunidad · Ola 4 → Empleo (Eventos salió: ola 3 adelantada, 2-sep-2026)
  ],

  features: [],

  // El grupo se muestra si el rol tiene 'ver' sobre alguno de estos.
  permisoModulos: ['formacion', 'eventos'],

}
